import React__default from 'react';
import Icons from '../../public/svg/icons.svg.js';

const Sprite = () => /*#__PURE__*/React__default.createElement(Icons, null);
Sprite.displayName = 'NuiSprite';
var Sprite$1 = Sprite;

export { Sprite$1 as default };
